module.exports = __webpack_public_path__ + "static/grid-layouts-13ea4007d7273bf5711db51ec10ff960.png";